/**
 * Call in `getInitialProps()` / `getServerSideProps()`
 */

export interface IEnrichTelemetryData {
  customerNumber?: string | -1;
  isLoggedIn?: boolean;
  userId?: number;
  userName?: string;
}

export const enrichTelemetryData = async ({ customerNumber, isLoggedIn, userId, userName }: IEnrichTelemetryData) => {
  if (typeof window === 'undefined') {
    // @ts-expect-error: appInsights is preloaded via npm commands
    const appInsights = global?.appInsights;

    // `server.js` not pre-loaded, do not attempt to add custom properties
    if (!appInsights) {
      return;
    }

    appInsights.defaultClient.context.tags[appInsights.defaultClient.context.keys.cloudRole] = 'NextJS-ServerSide';

    const addCustomProperties = (envelope: any) => {
      // Add custom properties to every telemetry item
      envelope.data.baseData.properties = envelope.data.baseData.properties || {};

      customerNumber && (envelope.data.baseData.properties.CustomerNumber = String(customerNumber));
      isLoggedIn && (envelope.data.baseData.properties.IsLoggedIn = String(isLoggedIn));
      userId && (envelope.data.baseData.properties.UserId = String(userId));
      userName && (envelope.data.baseData.properties.UserName = String(userName));

      return true;
    };

    // TODO: Find a better solution

    // Make sure this processor is added once or replaced if it exsist.
    // Otherwise it's added on every page request and you endup with a long array of the same processor function.
    // It's a hack that works because TS is compiled to JS and JS has no notion of 'private' fields.

    /* eslint-disable no-underscore-dangle */
    const processors = appInsights.defaultClient?._telemetryProcessors;
    const idx = processors?.findIndex((fn: AppCallbackFn) => fn?.name === 'addCustomProperties');

    if (idx > -1) {
      appInsights.defaultClient._telemetryProcessors[idx] = addCustomProperties;
    } else {
      // internally this is a `_telemetryProcessors.push()` without any checking
      appInsights.defaultClient.addTelemetryProcessor(addCustomProperties);
    }
  }
};
